import { keyframes } from 'styled-components'

export const blinkKeyframesColor = keyframes`
  0% {
    outline: 2px solid var(--tds-information);
  }
  50% {
    outline: none;
  }
  100% {
    outline: 2px solid var(--tds-information);
  }
`
